import { ShopFieldsFragment } from "client/graphql/commerce-api"

import Cart from "./cart/Cart"
import { useCartContext } from "./cart/CartContext"
import ProductFlow from "./product/ProductFlow"
import { CommerceView, useShopContext } from "./ShopContext"

export type CommerceFlowProps = {
  shop: ShopFieldsFragment
}

const CommerceFlow = ({ shop }: CommerceFlowProps) => {
  const { view, setView } = useShopContext()
  const { activeSale } = shop
  const { cart } = useCartContext()

  if (activeSale) {
    return view === CommerceView.PRODUCT ? (
      <ProductFlow
        shop={shop}
        showCart={() => setView(CommerceView.CART)}
      />
    ) : (
      <Cart />
    )
  }

  return cart && cart.totalQuantity > 0 ? <Cart /> : null
}

export default CommerceFlow
